import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSidePanel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.331 3.818 C 2.908 3.951,2.515 4.310,2.352 4.712 L 2.260 4.940 2.260 12.000 L 2.260 19.060 2.353 19.291 C 2.484 19.616,2.810 19.957,3.129 20.104 L 3.380 20.220 12.000 20.220 L 20.620 20.220 20.871 20.104 C 21.190 19.957,21.516 19.616,21.647 19.291 L 21.740 19.060 21.740 12.000 L 21.740 4.940 21.647 4.710 C 21.518 4.389,21.217 4.073,20.888 3.911 L 20.622 3.780 12.061 3.772 C 5.060 3.766,3.469 3.775,3.331 3.818 M15.000 12.000 L 15.000 18.760 9.380 18.760 L 3.760 18.760 3.760 12.000 L 3.760 5.240 9.380 5.240 L 15.000 5.240 15.000 12.000 M20.240 12.000 L 20.240 18.760 18.360 18.760 L 16.480 18.760 16.480 12.027 C 16.480 8.323,16.492 5.281,16.507 5.267 C 16.521 5.252,17.367 5.240,18.387 5.240 L 20.240 5.240 20.240 12.000 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgSidePanel;
